import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import imgLogoText from '../../assets/images/logoText.png'
import iconSuccess from '../../assets/images/automatedTrafficFineNotificationSuccess.png'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { PATH } from '../../constants/router'
import { number_to_price } from '../../helper/common'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { checkDurationUsageDate } from '../../components/FeaturesComponent/automatedTrafficFineNotificationServiceCard'
import { smartParseParam } from '../../helper/params'
import appUserService from '../../services/appUserService'
import { extractServicesAndVehiclesInOrderDetail } from '../../hooks/useAutomatedTrafficFineNotificationPayment'
import { CUSTOMER_RECEIPT_STATUS_TO_TEXT } from '../../constants/global'
import { ORDER_PAYMENT_STATUS_COLOR, PAYMENT_FAILED, PAYMENT_SUCCESS } from '../../constants/payment'
import './index.scss'

export default function AutomatedTrafficFineNotificationSuccess() {
  const history = useHistory()
  const { id: orderId } = useParams()
  const [services, setServices] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [orderDetail, setOrderDetail] = useState(null)

  const [showAllVehicles, setShowAllVehicles] = useState(false)
  const displayedVehicles = showAllVehicles ? vehicles : vehicles.slice(0, 1)

  const REACT_APP_MINIAPP_VIETTEL_MONEY = smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)

  const orderStatus = CUSTOMER_RECEIPT_STATUS_TO_TEXT[orderDetail?.paymentStatus?.toUpperCase()] || ''
  const colorStatus = ORDER_PAYMENT_STATUS_COLOR.find((item) => item.value === orderDetail?.paymentStatus)?.color

  const orderStatusTitle = useMemo(() => {
    if (orderDetail?.paymentStatus === PAYMENT_SUCCESS) {
      return 'thành công'
    } else if (orderDetail?.paymentStatus === PAYMENT_FAILED) {
      return 'thất bại'
    } else {
      return ''
    }
  }, [orderDetail?.paymentStatus])

  const getOrderDetailData = useCallback(async (orderId) => {
    try {
      const orderResult = await appUserService.getOrderDetail({ id: orderId })
      if (orderResult?.statusCode === 200 && orderResult?.data) {
        const orderDetail = orderResult.data
        setOrderDetail(orderDetail)
        const { services, vehicles } = extractServicesAndVehiclesInOrderDetail(orderDetail?.orderItems || [])
        setServices(services)
        setVehicles(vehicles)
      }
    } catch (error) {}
  }, [])

  useEffect(() => {
    if (orderId) {
      getOrderDetailData(orderId)
    }
  }, [getOrderDetailData, orderId])

  return (
    <LayoutPartner blendHeaderWithBody={false} onGoBack={() => history.push('/')}>
      <div className="AutomatedTrafficFineNotificationSuccess">
        {!!REACT_APP_MINIAPP_VIETTEL_MONEY && (
          <div className="AutomatedTrafficFineNotificationSuccess_top">
            <img src={imgLogoText} alt="" />
            <span></span>
          </div>
        )}
        <div className="AutomatedTrafficFineNotificationSuccess_image">
          <img src={iconSuccess} alt="" />
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_total">
          <div className="total_label">Mua gói thông báo phạt nguội {orderStatusTitle}</div>
          <div className="total_value">
            <strong>{number_to_price(orderDetail?.totalAmount || 0)}</strong>đ
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Nội dung</div>
            <div className="text_value">Mua gói thông báo phạt nguội</div>
          </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Gói dịch vụ</div>
            <div className="text_value">{services[0]?.productName || '-'}</div>
          </div>
          {/* Thông tin xe */}
          {displayedVehicles.map((vehicle, index) => (
            <div key={index} className="AutomatedTrafficFineNotificationSuccess_item">
              <div className="text_color_secondary">Thông tin xe {vehicles.length > 1 && (showAllVehicles || index > 0) ? `(${index + 1})` : ''}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text_value">{vehicle.plate || '-'}</span>
                {vehicles.length > 1 &&
                  index === 0 &&
                  (showAllVehicles ? (
                    <DownOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(false)} />
                  ) : (
                    <RightOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(true)} />
                  ))}
              </div>
            </div>
          ))}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thời hạn</div>
            <div className="text_value">{checkDurationUsageDate(services[0]?.usageDate || 30)}</div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Số tiền</div>
            <div className="text_value">{number_to_price(orderDetail?.subTotalAmount || 0)}đ</div>
          </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thuế VAT (10%)</div>
            <div className="text_value">{number_to_price(orderDetail?.taxAmount || 0)}đ</div>
          </div>
          {orderDetail?.discountAmount > 0 && (
            <div className="AutomatedTrafficFineNotificationSuccess_item">
              <div className="text_color_secondary">Mã giảm giá</div>
              <div className="text_value">{number_to_price(orderDetail?.discountAmount || 0)}đ</div>
            </div>
          )}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Tổng tiền thanh toán</div>
            <div className="text_value">{number_to_price(orderDetail?.totalAmount || 0)}đ</div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
          {REACT_APP_MINIAPP_VIETTEL_MONEY ? (
            <>
              <div className="AutomatedTrafficFineNotificationSuccess_item">
                <div className="text_color_secondary">Tài khoản thanh toán</div>
                <div className="text_bold text_value">ViettelPay</div>
              </div>
              <div className="AutomatedTrafficFineNotificationSuccess_item">
                <div className="text_color_secondary">Tài khoản nhận</div>
                <div className="text_bold text_value">Viễn thông</div>
              </div>
            </>
          ) : (
            <div className="AutomatedTrafficFineNotificationSuccess_item">
              <div className="text_color_secondary">Trạng thái</div>
              <div className="text_bold text_value" style={{ fontWeight: 'bold', color: colorStatus }}>
                {orderStatus}
              </div>
            </div>
          )}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Mã giao dịch</div>
            <div className="text_bold text_value">{orderDetail?.orderCode || orderDetail?.orderData?.orderCode || '-'}</div>
          </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thời gian</div>
            <div className="text_bold text_value">
              {orderDetail?.updatedAt || orderDetail?.orderData?.updatedAt
                ? new Date(orderDetail?.updatedAt || orderDetail?.orderData?.updatedAt).toLocaleString('vi-VN')
                : '-'}
            </div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          <BaseButton onClick={() => history.push('/')}>Về trang chủ</BaseButton>
        </FixedBottom>
      </div>
    </LayoutPartner>
  )
}
